import { css } from '@emotion/css';
import React from 'react';
import { ReactComponent as Side } from 'src/assets/images/fortune/img_ribbon_green_side.svg';

const ribbonBody =
  'data:image/svg+xml,%3Csvg width="196" height="36" preserveAspectRatio="none" viewBox="0 0 196 36" xmlns="http://www.w3.org/2000/svg"%3E%3Cpath d="M2.177 0H193.823c1.529.06 2.306.46 2.159 2.264-.008.13-.008.252 0 .356l-2.28 30.578c-.199 1.71-.518 2.672-2.721 2.802H5.019c-2.203-.13-2.522-1.093-2.721-2.802L.018 2.62c.005-.063.007-.134.006-.208l-.006-.148C-.13.46.648.06 2.177 0z" fill="%2348C058"/%3E%3C/svg%3E';

export const GreenRibbon: React.FC = ({ children }) => {
  return (
    <div
      className={css`
        position: relative;
        display: inline-block;

        .ribbon-body {
          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
          background: url('${ribbonBody}');
          background-size: 100% 100%;
          background-repeat: no-repeat;
          min-height: 32px;
          padding: 4px 16px;
        }
        .ribbon-text {
          text-align: center;
          color: white;
          font-size: 14px;
          line-height: 1.2;
          z-index: 1;
        }
        .ribbon-side {
          position: absolute;
          bottom: -6px;
        }
        .ribbon-left {
          right: -13px;
        }
        .ribbon-right {
          left: -13px;
          transform: scaleX(-1);
        }
        @media screen and (min-width: 330px) {
          .ribbon-body {
            min-height: 36px;
          }
          .ribbon-text {
            font-size: 18px;
          }
          .ribbon-side {
            bottom: -4px;
          }
        }
      `}
    >
      <Side className="ribbon-side ribbon-left" />
      <Side className="ribbon-side ribbon-right" />
      <div className="ribbon-body">
        <span className="ribbon-text">{children}</span>
      </div>
    </div>
  );
};
